export default "__VITE_ASSET__qTT3WhBX__"